const state = {
  menus: {
    buildings: false,
    complexes: false,
    main: false,
  },
};

const getters = {
  getMenus: (state) => state.menus,
  getBuildingsMenu: (state) => state.menus.buildings,
  getComplexesMenu: (state) => state.menus.complexes,
  getMainMenu: (state) => state.menus.main,
};

const mutations = {
  setBuildingsMenu: function (state, menuStatus) {
    state.menus.buildings = menuStatus;
  },
  setComplexesMenu: function (state, menuStatus) {
    state.menus.complexes = menuStatus;
  },
  setMainMenu: function (state, menuStatus) {
    state.menus.main = menuStatus;
  },
};

const actions = {
  hideMenu({ commit }) {
    document.querySelector("body").classList.remove("mobile-menu-active");
    commit("setMainMenu", false);
    // commit("setBuildingsMenu", false);
    // commit('setComplexesMenu', false);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/menus.js